/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { ThemeProvider } from '../ThemeProvider';

export interface AppContextProviderProps {
    children: React.ReactElement;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => (
    <ThemeProvider>
        {children}
    </ThemeProvider>
);
